(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lakerun-pattern-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lr-pattern-stories')) {
    customElements.define('lr-pattern-stories', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-story-track]');
        this.slides = [...this.querySelectorAll('[data-story-slide]')];
        this.choices = [...this.querySelectorAll('[data-story-index]')];
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;
        this.querySelectorAll('[data-story-controls]').forEach(control => { control.hidden = false; });
        this.choices.forEach(control => control.addEventListener('click', () => this.go(Number(control.dataset.storyIndex)), options));
        this.querySelectorAll('[data-story-step]').forEach(control => control.addEventListener('click', () => this.go(this.index + Number(control.dataset.storyStep)), options));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.slides.length - 1);
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.sync());
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index, true);
        }, options);
        this.resizeObserver = new ResizeObserver(() => { this.go(this.index, true); this.fitHeight(); });
        this.resizeObserver.observe(this.track);
        this.slides.forEach(slide => this.resizeObserver.observe(slide));
        this.sync();
      }
      go(index, immediate = false) {
        const next = (index + this.slides.length) % this.slides.length;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = this.slides[next].getBoundingClientRect();
        const delta = rtl ? slideRect.right - trackRect.right : slideRect.left - trackRect.left;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: immediate || reducedMotion ? 'instant' : 'smooth' });
      }
      fitHeight() {
        const height = Math.ceil(this.slides[this.index].getBoundingClientRect().height);
        if (height > 0 && this.track.style.height !== `${height}px`) this.track.style.height = `${height}px`;
      }
      sync() {
        const trackRect = this.track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const gap = Math.abs(rect.left + rect.width / 2 - center);
          if (gap < distance) { distance = gap; nearest = index; }
        });
        const changed = this.index !== nearest;
        this.index = nearest;
        this.fitHeight();
        this.choices.forEach(control => control.setAttribute('aria-pressed', String(Number(control.dataset.storyIndex) === nearest)));
        this.slides.forEach((slide, index) => {
          const active = index === nearest;
          if (!active && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        if (changed) this.querySelector('[data-story-status]').textContent = this.slides[nearest].getAttribute('aria-label');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lakerun-reeling-ac"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lr-ac-feature')) {
    customElements.define('lr-ac-feature', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const gallery = this.querySelector('[data-ac-gallery]');
        const controls = this.querySelector('[data-ac-controls]');
        if (!gallery || !controls) return;
        const buttons = [...this.querySelectorAll('[data-ac-step]')];
        const update = () => {
          const max = gallery.scrollWidth - gallery.clientWidth;
          controls.hidden = max < 5;
          buttons.forEach(button => { button.disabled = Number(button.dataset.acStep) < 0 ? gallery.scrollLeft < 5 : gallery.scrollLeft >= max - 5; });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const width = gallery.querySelector('.lr-ac__photo')?.getBoundingClientRect().width || gallery.clientWidth;
          const gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
          gallery.scrollBy({ left: (width + gap) * Number(button.dataset.acStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        gallery.addEventListener('scroll', update, { passive: true, signal });
        this.resize?.disconnect();
        this.resize = new ResizeObserver(update);
        this.resize.observe(gallery);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
